import React, { useEffect, useState } from "react";
import styles from "./DDPICompleted.module.scss";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";
import { GetStatusDDPIAPICall } from "../DDPIAPICalls";

function MainCompleted() {
  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>DDPI Enabled</p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                DDPI has been Enabled successfully.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainCompleted;
